export default __webpack_public_path__ + "static/media/external-link-alt-solid.fb491fbc.svg";